console.log('force-size-selection.js loaded');

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const pickers = document.querySelectorAll('variant-radios, variant-selects');
    const payBtn = document.querySelector('.shopify-payment-button, [data-shopify="payment-button"]');
    if (payBtn) payBtn.style.setProperty('display', 'none', 'important');

    pickers.forEach(function (picker) {
      picker.dispatchEvent(new Event('change', { bubbles: true }));
      picker.addEventListener('change', function () {
        const hasSelection = Array.from(picker.querySelectorAll('fieldset')).every(
          fieldset => fieldset.querySelector('input:checked')
        );
        if (hasSelection && payBtn) {
          payBtn.style.removeProperty('display');
        } else if (payBtn) {
          payBtn.style.setProperty('display', 'none', 'important');
        }
      });
    });
  }, 800);
});

const rzpBtnObserver = new MutationObserver(function() {
  // Hide Razorpay's magic button
  const magicBtnParent = document.querySelector('.magic-buy-btn__parent');
  if (magicBtnParent) {
    magicBtnParent.style.setProperty('display', 'none', 'important');
  }

  const nativeBtn = document.querySelector('.shopify-payment-button');
  if (nativeBtn && nativeBtn.classList.contains('magic-hide')) {
    nativeBtn.classList.remove('magic-hide');

    // Disable inner button to prevent native checkout flash
    const innerBtn = nativeBtn.querySelector('shopify-buy-it-now-button, button');
    if (innerBtn) {
      innerBtn.style.setProperty('pointer-events', 'none', 'important');
    }

    // Capture click on wrapper and route to Magic Checkout
    nativeBtn.style.cursor = 'pointer';
    nativeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const magicBtn = document.querySelector('magic-checkout-btn');
      if (magicBtn) {
        setTimeout(function() {
          magicBtn.click();
        }, 50);
      }
    }, { capture: true });
  }
});

rzpBtnObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributeFilter: ['class']
});